export default {"src":"/_next/static/media/percent.ea0fa825.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};